<template>
	<div class="new-tool-form">
		<h2 class="new-tool-form-title"
			:style="`color:${$appColors.info};border-bottom:1px solid ${$appColors.gray}`"
		>{{formTitle}}</h2>
		<form>
			<div class="form">
				<section class="general-section">
					<h3 class="section-title mb-3 pb-2"
						:style="`color:${$appColors.primary};border-bottom:1px solid ${$appColors.gray}`"
					>Datos generales</h3>
					<div class="code">
						<label for="new-tool-code"
							:style="`color:${$appColors.info}`"
						>
							Código
							<input
								id="new-tool-code"
								class="new-survey-input" 
								placeholder="Código"
								v-model="newTool.code"
							/>
						</label>
					</div>
					<div class="name">
						<label for="new-tool-name"
							:style="`color:${$appColors.info}`"
						>
							Nombre de la Herramienta
							<input
								id="new-tool-name"
								class="new-survey-input" 
								placeholder="Nombre"
								v-model="newTool.name"
							/>
						</label>
					</div>
					<div class="description">
						<label for="new-tool-description"
							:style="`color:${$appColors.info}`"
						>
							Descripción de la Herramienta
							<textarea
								id="new-tool-description"
								class="new-survey-input" 
								placeholder="Descripción"
								v-model="newTool.description"
							/>
						</label>
					</div>
					<div class="d-flex mt-3 mb-4">
						<app-button
							class="btn-tool selecting-template-tool"
							:style="`background-color:${urlImage ? $appColors.success : $appColors.info}`"
							text="Seleccionar Ícono"
							@click="goTo('tool-icons', { params: { type: 'TOOLS'} })"
						/>
						<app-button
							class="btn-tool selecting-template-tool"
							:style="`background-color:${templateId ? $appColors.success : $appColors.info}`"
							text="Tipo de Herramienta"
							@click="goTo('tool-type')"
						/>
						<app-button
							class="btn-tool selecting-template-tool"
							:style="`background-color:${answerId ? $appColors.success : $appColors.info}`"
							text="Tipo de Respuesta"
							@click="goTo('answer-selection')"
						/>
					</div>
				</section>
				<section class="media-section">
					<div>
						<h3 class="section-title mb-3 pb-2"
							:style="`color:${$appColors.primary};border-bottom:1px solid ${$appColors.gray}`"
						>Imágenes</h3>
						<div class="img-container">
							<label class="img-label"
								:style="`color:${$appColors.info}`"
							>
								Imágenes
								<file-load-input
									placeholder="cargar imagen"
									allowed-file-extensions=".png, .jpg, .jpeg, .svg"
									v-model="newTool.image"
								/>
							</label>
							<app-button
								:disabled="!newTool.image"
								class="img-btn"
								icon="add"
								@click="addImage"
							/>
							<div class="img-link-container">
								<div
									class="img-link"
									v-for="(img, indexImg) in newTool.images"
									:key="indexImg"
								>
									<img :src="img.url" alt="Imagen">
									<app-button
										class="img-btn"
										icon="close"
										:style="`background-color:${$appColors.success}`"
										@click="deleteImg"
									/>
								</div>
							</div>
						</div>
					</div>
					<div>
						<h3 class="section-title mb-3 pb-2"
							:style="`color:${$appColors.primary};border-bottom:1px solid ${$appColors.gray}`"
						>Videos</h3>
						<div class="video-container">
							<label class="video-label"
								:style="`color:${$appColors.info}`"
							>
								Videos
								<input
									:style="`color:${$appColors.info}`"
									class="new-survey-input" 
									placeholder="Pegar enlace de video"
									v-model="newTool.videoLink"
									@keyup.enter="addVideo"
								/>
							</label>
							<app-button
								:disabled="!newTool.videoLink"
								class="video-btn"
								icon="add"
								@click="addVideo"
							/>
							<div class="video-link-container">
								<div
									class="videos-link"
									v-for="(video, indexVi) in newTool.videos"
									:key="indexVi"
									:style="`border-top:1px solid ${$appColors.gray}`"
								>
									<span :style="`color:${$appColors.info}`">{{video.url}}</span>
									<app-tooltip-button
										img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
										text="Eliminar"
										@click-icon="deleteVideo(indexVi)"
									/>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</form>
		<div class="new-toolform-btn mt-4">
			<app-button
				class="btn-tool px-4 py-2"
				:style="`background-color:${$appColors.error}`"
				text="Cancelar"
				@click="goTo('tools-list')"
			/>
			<app-button
				:disabled="$v.$invalid"
				class="btn-tool px-4 py-2"
				text="Guardar"
				:style="`background-color:${$appColors.primary}`"
				@click="createNewTool"
			/>
		</div>
		<router-view name="toolType"></router-view>
		<router-view name="toolIcons"></router-view>
		<router-view name="answerSelection"></router-view>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import { required, minValue, minLength } from 'vuelidate/lib/validators';
import appButton from '@/components/shared/app-button';
import fileLoadInput from '@/components/shared/load-file-input';

function created() {
	const { code } = this.$route.params;
	if (code) {
		this.$store.dispatch('tool/loadTool', code);
	}
}

function formTitle() {
	return this.$route.meta.title;
}

async function createNewTool() {
	const body = this.buildBody();
	const action = this.flagEdit ? 'editTool' : 'createNewTool';
	const message = this.flagEdit ? 'actualizada' : 'creada';
	try {
		await this.$store.dispatch(`tool/${action}`, body);
		this.showNotification(
			`La herramienta ${body.name} fue ${message} exitosamente`,
			'success',
		);
		this.cleanToolsForm();
		this.goTo('tools-list');
	} catch (error) {
		this.showNotification();
	}
}

function cleanToolsForm() {
	this.$store.dispatch('tool/setNewToolData', this.emptyNewToolData());
	this.$store.dispatch('icon/selectIconAction', null);
	this.$store.dispatch('answer/selectedTypeAnswer', null);
}

function emptyNewToolData() {
	this.newTool = {
		code: '',
		description: '',
		image: '',
		images: [],
		name: '',
		templateId: 0,
		urlImage: '',
		videos: [],
		videoLink: '',
	};
	return this.newTool;
}

function buildBody() {
	const body = {
		answerId: this.answerId,
		code: this.newTool.code,
		description: this.newTool.description,
		images: this.newTool.images,
		name: this.newTool.name,
		templateId: this.templateId,
		urlImage: { web: this.urlImage, movil: this.urlImage },
		videos: this.newTool.videos,
	};
	if (this.flagEdit) {
		body.id = this.toolId;
	}
	return body;
}

function beforeDestroy() {
	this.$store.dispatch('tool/setNewToolData', this.newTool);
	this.$store.dispatch('tool/setFlagEditTool', 0);
}

function addVideo() {
	this.newTool.videos.push({ url: this.newTool.videoLink });
	this.newTool.videoLink = '';
}

function addImage() {
	this.newTool.images.push({ url: this.newTool.image });
	this.newTool.image = '';
}

function deleteVideo(index) {
	this.newTool.videos.splice(index, 1);
}

function deleteImg(index) {
	this.newTool.images.splice(index, 1);
}

function flagEdit(flag) {
	if (flag) {
		this.newTool = { ...this.editingData };
	}
}

function validations() {
	return {
		answerId: { minValue: minValue(1) },
		templateId: { minValue: minValue(1) },
		urlImage: { required },
		newTool: {
			code: { required },
			description: { required },
			images: { required, minLength: minLength(1) },
			name: { required },
			videos: { required, minLength: minLength(1) },
		},
	};
}

function data() {
	return {
		newTool: {
			code: '',
			description: '',
			image: '',
			images: [],
			name: '',
			templateId: 0,
			urlImage: '',
			videos: [],
			videoLink: '',
		},
	};
}

export default {
	name: 'new-tool-form',
	beforeDestroy,
	components: {
		appButton,
		fileLoadInput,
	},
	computed: {
		...mapState('answer', {
			answerId: state => state.answers.typeAnswerSelectedId,
		}),
		...mapState('icon', {
			urlImage: state => state.selectedIcon && state.selectedIcon.urlImage,
		}),
		...mapState('tool', {
			editingData: state => state.editing.toolData,
			flagEdit: state => !!state.editing.id,
			templateId: state => state.templateId,
			toolId: state => state.editing.id,
		}),
		formTitle,
	},
	created,
	data,
	methods: {
		addImage,
		addVideo,
		buildBody,
		cleanToolsForm,
		createNewTool,
		deleteImg,
		deleteVideo,
		emptyNewToolData,
	},
	validations,
	watch: {
		flagEdit,
	},
};
</script>
<style lang="scss" scoped>
.new-tool-form {
	background-color: white;
	border: 1px solid #e9e9e9;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
	margin-bottom: 21px;
	padding: 24px 0;

	.new-tool-form-title {
		font-family: font(bold);
		font-size: size(xlarge);
		margin-bottom: 22px;
		padding: 0 33px 12px;
	}

	label {
		font-size: size(small);

		input::placeholder {
			font-size: size(medium);
		}
	}

	.form {
		align-items: flex-start;
		display: flex;
		padding: 0 23px;

		.general-section, .media-section {
			flex-basis: 50%;
			padding: 0 10px;

			.code {
				width: 50%;
			}

			.code, .name, .description {
				margin-bottom: 15px;
			}

			.img-container, .video-container {
				align-items: flex-end;
				display: flex;
				flex-wrap: wrap;
				margin-bottom: 20px;

				.img-label, .video-label {
					flex-basis: 86%;
					margin-bottom: 25px;
				}


				.img-btn, .video-btn {
					border-radius: 4px;
					flex-basis: 12%;
					height: 32px;
					margin-bottom: 25px;
					margin-left: 5px;
				}

				.img-link-container, .video-link-container {
					align-items: flex-end;
					display: flex;
					flex-basis: 100%;
					overflow: auto;
					padding-top: 7px;
					max-width: 335px;
				}

				.img-link {
					height: 90px;
					position: relative;
					margin: 0 5px;
					max-width: 140px;
					min-width: 140px;

					img {
						height: 100%;
						object-fit: contain;
						width: 100%;
					}

					.img-btn {
						border-radius: 50%;
						height: 25px;
						position: absolute;
						top: -7px;
						right: -7px;
						width: 25px;
					}
				}

				.video-link-container {
					flex-wrap: wrap;
					max-height: 127px;

					.videos-link {
						align-items: center;
						display: flex;
						flex-basis: 100%;
						justify-content: space-between;
						padding: 0 5px;
					}
				}

			}
		}

		.btn-tool {
			border-radius: 4px;
			color: white;
			font-family: font(bold);
			font-size: size(small);
			height: 34px;
			margin: 0 5px;
			padding: 5px 15px;
		}

		.selecting-template-tool {
			white-space: nowrap;
		}
	}
}

.new-toolform-btn {
	align-items: center;
	display: flex;
	justify-content: center;
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/new-tool-form.vue